/**
 * @Description 标准版-门店管理
 */

import { get, post } from '@/common/request/index';

/**
 * @description 门店列表
 * https://yapi.lanhanba.com/project/532/interface/api/60878（旧文档）
 * https://yapi.lanhanba.com/project/546/interface/api/85749（新文档，以此为准）
 */
export function getShopList(params?:any) {
  return post('/standard/shop/page', { ...params }, {
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
    needHint: true,
  });
}

/**
 * @description 门店列表（分享使用）
 * https://yapi.lanhanba.com/project/546/interface/api/85756
 */
export function getShopListShare(params?:any) {
  return post('/standard/shop/share/page', { ...params }, {
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
    needHint: true,
  });
}

/**
 * @description 更新门店名称
 * https://yapi.lanhanba.com/project/532/interface/api/60885
 */
export function updateShopName(params?:any) {
  return post('/standard/shop/update/name', params, {
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
    needHint: true,
  });
}

/**
 * @description 更新门店状态
 * https://yapi.lanhanba.com/project/532/interface/api/60892
 */
export function updateShopStatus(params?:any) {
  return post('/standard/shop/update/status', params, {
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
    needHint: true,
  });
}

/**
 * @description 状态记录
 * https://yapi.lanhanba.com/project/532/interface/api/60913
 */
export function shopStatusRecords(params?:any) {
  return post('/standard/shop/status/record', { ...params }, {
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
    needHint: true,
  });
}

/**
 * @description 可变更的状态列表
 * https://yapi.lanhanba.com/project/532/interface/api/60920
 */
export function shopStatusList(params?:any) {
  return post('/standard/shop/status/list', { ...params }, {
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
    needHint: true,
  });
}

/**
 * @description 筛选项列表
 * https://yapi.lanhanba.com/project/532/interface/api/60941
 */
export function shopSelection(params?:any) {
  return post('/standard/shop/selection/list', { ...params }, {
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
    needHint: true,
  });
}

/**
 * @description 合同到期预警-门店个数
 * @yapi https://yapi.lanhanba.com/project/532/interface/api/72183
 */
export function getContractExpiration(params:any) {
  return post('/standard/home/contractExpiration', params, {
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
    needHint: true
  });
}
/*
 * @description 门店列表-动态表头配置
 * https://yapi.lanhanba.com/project/532/interface/api/72190
 */
export function getShopListColumn(params?:any) {
  return get('/standard/shop/setting/header', { ...params }, {
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
    needHint: true,
  });
}

/**
 * @description 新增门店
 * https://yapi.lanhanba.com/project/329/interface/api/88820
 */
export function createShop(params?:any) {
  return post('/standard/shop/create', { ...params }, {
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
    needHint: true,
  });
}

/**
 * @description 新增门店(会刷新地图门店cdn)
 * https://yapi.lanhanba.com/project/349/interface/api/89040
 */
export function youthMapCreateShop(params?:any) {
  return post('/youth/map/standard/shop/create', { ...params }, {
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
    needHint: true,
  });
}

/**
 * @description 门店列表-编辑详情
 * https://yapi.lanhanba.com/project/532/interface/api/72330
 */
export function getShopDetail(params?:any) {
  return post('/standard/shop/detail', { ...params }, {
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
    needHint: true,
  });
}

/**
 * @description 门店列表-编辑保存
 * https://yapi.lanhanba.com/project/532/interface/api/72337
 */
export function shopUpdate(params?:any) {
  return post('/standard/shop/update', { ...params }, {
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
    needHint: true,
  });
}

/**
 * @description 门店列表-拓店日志
 * https://yapi.lanhanba.com/project/532/interface/api/73569
 */
export function getShopExpandRecord(params?:any) {
  return post('/standard/shop/expand/record', { ...params }, {
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
    needHint: true,
  });
}

/**
 * @description 机会点-合同签约详情
 * https://yapi.lanhanba.com/project/532/interface/api/72344
 */
export function getContractDetail(params?:any) {
  return post('/standard/chancePoint/sign/detail', { ...params }, {
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
    needHint: true,
  });
}

/**
 * @description 机会点-合同签约保存
 * https://yapi.lanhanba.com/project/532/interface/api/72351
 */
export function contractUpdate(params?:any) {
  return post('/standard/chancePoint/contractSign', { ...params }, {
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
    needHint: true,
  });
}


/**
 * @description 门店列表导出
 * https://yapi.lanhanba.com/project/532/interface/api/72358
 */
export function exportShopList(params?:any) {
  return post('/standard/shop/export', { ...params }, {
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
    needHint: true,
  });
}

/**
 * @description 机会点门店详情
 * https://yapi.lanhanba.com/project/532/interface/api/73520
 */
export function getChancePointShopDetail(params?:any) {
  return post('/standard/chancePoint/shop/detail', { ...params }, {
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
    needHint: true,
  });
}


/**
 * @description 机会点门店详情
 * https://yapi.lanhanba.com/project/532/interface/api/73520
 */
export function deleteShop(params?:any) {
  return post('/standard/shop/deleteById', { ...params }, {
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
    needHint: true,
  });
}


/**
 * @description 合同签约前置校验
 * https://yapi.lanhanba.com/project/623/interface/api/87660
 */
export function checkContractSign(params:any) {
  return post('/standard/chancePoint/contractSign/preValidate', { ...params }, {
    isMock: false,
    mockId: 623,
    mockSuffix: '/api',
    needHint: true,
  });
}
